import React from 'react';

const MembershipSummaryBanner = ({ formData }) => {
  if (!formData || !formData.membershipType) return null;

  const {
    membershipType,
    name,
    membershipPeriodQty: duration,
    membershipPeriodUnit: period,
    membershipItemsNeverExpire,
    rollOverTimeLimit,
    perPeriodQtyLimit,
    rollOverQtyLimit,
    unitPrice,
    membershipOfferBeginsOn,
    membershipOfferEndsOn
  } = formData;

  const periodLabel = period ? period.toLowerCase() : 'period';

  const typeLabel = {
    3: 'Option Package - Includes multiple options (services or products) that share a common pool of credits.',
    2: `Recurring - Each service or product receives its own separate set of credits every ${periodLabel}.`,
    1: 'Bank - Members receive a fixed number of credits for each service at the start of the membership.'
  }[membershipType] || 'Unknown';

  // 💲 Format price and 🗓️ dates
  const formatPrice = (val) =>
    typeof val === 'number' || !isNaN(val) ? `$${parseFloat(val).toFixed(2)}` : 'N/A';

  const formatDate = (val) => {
    if (!val) return null;
    const date = new Date(val);
    return isNaN(date) ? null : date.toLocaleDateString();
  };

  const bullets = [];
 
  if (membershipOfferBeginsOn) bullets.push(`This membership will be available starting on ${formatDate(membershipOfferBeginsOn)}.`);
  if (membershipOfferEndsOn) bullets.push(`It will no longer be offered after ${formatDate(membershipOfferEndsOn)}.`);
  if (unitPrice) bullets.push(`Clients will be charged ${formatPrice(unitPrice)} per ${periodLabel}.`);

  if (duration && periodLabel) bullets.push(`Membership lasts for ${duration} ${periodLabel}(s).`);



  // 📦 Type-specific descriptions
  if (membershipType === 1) {

     if (typeof perPeriodQtyLimit !== 'undefined')
      bullets.push(`Members receive ${perPeriodQtyLimit} credit(s) per ${periodLabel}.`);
   
    if (typeof rollOverQtyLimit !== 'undefined')
      bullets.push(`Up to ${rollOverQtyLimit} unused credit(s) can roll over each ${periodLabel}.`);

    if (!membershipItemsNeverExpire) bullets.push(`Credits can roll over for up to ${rollOverTimeLimit || 0} additional ${periodLabel}(s) from when they are granted.`);
  }

  if (membershipItemsNeverExpire) bullets.push('Credits never expire.');

  return (
    <div style={bannerStyle}>
      <h3 style={{ marginBottom: '6px' }}>{name || 'Unnamed Membership'}</h3>
      <p><strong>Type:</strong> {typeLabel}</p>
      <ul style={{ paddingLeft: '1.25rem', marginTop: '0.5rem' }}>
        {bullets.map((text, idx) => (
          <li key={idx} style={{ marginBottom: '4px' }}>{text}</li>
        ))}
      </ul>
    </div>
  );
};

const bannerStyle = {
  backgroundColor: '#f5f5f5',
  border: '1px solid #ddd',
  borderRadius: '4px',
  padding: '16px',
  marginBottom: '20px',
  lineHeight: '1.5',
  fontSize: '0.95rem'
};

export default MembershipSummaryBanner;
